/* istanbul ignore file */
import { connect } from 'react-redux'
import StepPreBooking from './StepPreBooking'
import { requestUpdateBooking } from '../../actions/booking'
import { bookingDataSelector, updateBookingErrorSelector } from '../../selectors/booking'
import { localStorage } from '@elparking/utils'

function mapStateToProps (state) {
    const booking = bookingDataSelector(state)
    return {
        token: 'Bearer ' + localStorage.get('AUTH_TOKEN'),
        unbornId: booking && booking.id,
        error: !!updateBookingErrorSelector(state),
    }
}

export default connect(
    mapStateToProps,
    {
        requestUpdateBooking,
    }
)(StepPreBooking)
